import React, { ReactNode, useMemo } from 'react';

import usePalette from '@gojob/ui-bits/styles/PaletteProvider/usePalette';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import BlockContent from '@sanity/block-content-to-react';

export type BlockRendererProps = {
  blocks?: any;
};

const spanRenderer = (props: any) => (
  <Text as="p" css={{ whiteSpace: 'pre-wrap' }}>
    {props.children}
  </Text>
);

const listRenderer = (props: { children: ReactNode }) => {
  return <ul css={{ listStyleType: 'none', padding: 0, margin: 0 }}>{props.children}</ul>;
};

const listItemRenderer = (props: { children: ReactNode }) => {
  const { colors, spacing } = useTheme();
  const {
    list: { indent },
  } = usePalette();
  return (
    <li
      css={{
        fontSize: spacing(4.3),
        color: colors[indent],
        textShadow: '0 2px 4px rgba(0,0,0,0.8)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <span css={{ marginRight: spacing(2) }}>•</span>
      <Text css={{ fontSize: spacing(3) }}>{props.children}</Text>
    </li>
  );
};

const BlockRenderer = (props: BlockRendererProps) => {
  const { blocks } = props;

  const serializers = useMemo(() => {
    return {
      list: listRenderer,
      listItem: listItemRenderer,
      types: {
        block: spanRenderer,
      },
    };
  }, []);

  if (!blocks) {
    return null;
  }
  return <BlockContent blocks={blocks} serializers={serializers} />;
};

export default BlockRenderer;
